import "./G2ReviewWidget.css";
import * as React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'office-ui-fabric-react';
import { G2RatingSchemaUrl, G2ReviewUrl } from "../../utils/externalLinks";
import { ApplicationState } from "../../../store";
import { PPMFeatures, Subscription } from "../../../store/Tenant";

type G2Rating = {
    ratingValue: number;
    bestRating: number;
};

type OwnProps = {
    className?: string;
};

type StateProps = {
    subscription: Subscription;
};

type Props = OwnProps & StateProps;

const DEFAULT_BEST_RATING = 5

const G2ReviewWidget = (props: Props) => {
    const [rating, setRating] = React.useState<G2Rating>();
    const hasPartnersSupport = Subscription.contains(props.subscription, PPMFeatures.PartnersSupport);

    React.useEffect(() => {
        let cancelled = false;

        if (!hasPartnersSupport) {
            fetch(G2RatingSchemaUrl)
                .then(_ => _.json())
                .then(schema => {
                    const parsed = parseRating(schema?.aggregateRating);
                    if (!cancelled && parsed) {
                        setRating(parsed);
                    }
                })
                .catch(() => { });
        }

        return () => { cancelled = true; };
    }, [hasPartnersSupport]);

    if (hasPartnersSupport) {
        return null;
    }

    return <div className={`g2-review-widget${props.className ? ` ${props.className}` : ''}`}>
        <div className="g2-review-widget-text">
            <div className="g2-review-widget-title">Like PPM Express?</div>
            <div className="g2-review-widget-subtitle">Please share your experience - it takes just a couple of minutes</div>
        </div>
        {rating && <div className="g2-review-widget-rating">
            <span className="g2-review-widget-rating-value">{rating.ratingValue.toFixed(1)}</span>
            <div>
                <div className="g2-review-widget-stars">
                    {Array.from({ length: rating.bestRating }, (_, i) =>
                        <span key={i} className="g2-review-widget-star">
                            <Icon iconName="FavoriteStarFill" className="g2-review-widget-star-empty" />
                            <span className="g2-review-widget-star-fill" style={{ width: `${getStarFill(rating.ratingValue, i)}%` }}>
                                <Icon iconName="FavoriteStarFill" />
                            </span>
                        </span>)}
                </div>
                <div className="g2-review-widget-rating-caption">out of {rating.bestRating} on <b>G2</b></div>
            </div>
        </div>}
        <a className="g2-review-widget-button" href={G2ReviewUrl} target="_blank" title="Leave a review of PPM Express on G2">
            <Icon iconName="G2Logo" />
            <span>Review us on G2</span>
            <Icon iconName="Go" className="g2-review-widget-button-arrow" />
        </a>
    </div>;
};

const parseRating = (aggregateRating: { ratingValue?: unknown, bestRating?: unknown } | undefined): G2Rating | undefined => {
    const ratingValue = Number(aggregateRating?.ratingValue);
    const bestRating = aggregateRating?.bestRating == null ? DEFAULT_BEST_RATING : Number(aggregateRating.bestRating);

    if (!Number.isInteger(bestRating) || bestRating <= 0) {
        return undefined;
    }

    if (!Number.isFinite(ratingValue) || ratingValue <= 0 || ratingValue > bestRating) {
        return undefined;
    }
    
    return { ratingValue, bestRating };
};

const getStarFill = (ratingValue: number, starIndex: number) => Math.min(Math.max(ratingValue - starIndex, 0), 1) * 100;

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return {
        subscription: state.tenant.subscription,
    };
}

export default connect(mapStateToProps)(G2ReviewWidget);
